import { getClientConfig } from '../configuration/client-instance';
import type { IRequestOptions } from '../types';
import { resolveProviderHeaders } from './resolve-provider-headers';

export async function buildHeaders({
  options,
}: {
  options?: IRequestOptions;
}): Promise<Record<string, string>> {
  const config = getClientConfig();
  const providerHeaders = await resolveProviderHeaders(config.headerProvider);
  return {
    ...config.defaultHeaders,
    ...providerHeaders,
    ...options?.headers,
  };
}
